export const DODA_SITE_RECOMMENDTYPE = {
  // AWSRecommendSourceDetail (17 types)
  AWS_RECOMMEND: 'AWS_recommend',
  AWS_RECOMMEND_KYUJIN_SYOUSAI: 'AWS_Recommend_KyujinSyousai',
  AWS_RECOMMEND_ETSURAN_ETSURAN: 'AWS_Recommend_etsuran_etsuran',
  AWS_RECOMMEND_ETSURAN: 'AWS_Recommend_etsuran',
  AWS_RECOMMEND_ETSURAN_WRK_LOC_ORI: 'AWS_Recommend_etsuran_wrk_loc_ori',
  AWS_RECOMMEND_ETSURAN_WRK_LOC_AB: 'AWS_Recommend_etsuran_wrk_loc_AB',
  AWS_RECOMMEND_ETSURAN_SINE: 'AWS_Recommend_etsuran_SINE',
  AWS_RECOMMEND_NOT_ETSURAN: 'AWS_Recommend_not_etsuran',
  AWS_RECOMMEND_OUBO: 'AWS_Recommend_oubo',
  AWS_RECOMMEND_OUBO_WRK_LOC_ORI: 'AWS_Recommend_oubo_wrk_loc_ori',
  AWS_RECOMMEND_OUBO_WRK_LOC_AB: 'AWS_Recommend_oubo_wrk_loc_AB',
  AWS_RECOMMEND_KININARU: 'AWS_recommend_kininaru',
  AWS_RECOMMEND_RE_ETSURAN: 'AWS_Recommend_re_etsuran',
  AWS_RECOMMEND_ATTRIBUTE: 'AWS_Recommend_attribute',
  AWS_RECOMMEND_SKILLTAG: 'AWS_Recommend_skilltag',
  AWS_RECOMMEND_WRK_LOC_ORI: 'AWS_recommend_wrk_loc_ori',
  AWS_RECOMMEND_WRK_LOC_AB: 'AWS_recommend_wrk_loc_AB',
  AWS_RECOMMEND_LIGHT_SANS: 'AWS_recommend_LightSANs',

  // YOSHINANIRecommendSourceDetail (1 type)
  YOSHINANI_KIBOU_JOUKEN: 'YOSHINANI_kiboujouken',

  // KiraKiraRecommendSourceDetail (5 types)
  RANKING_ALL: 'ranking_all',
  RANKING_OCL: 'ranking_ocl',
  RANKING_OCL_INCOME: 'ranking_ocl_income',
  RANKING_SHIKOSEI: 'ranking_shikosei',
  RANKING_OCL_PF: 'ranking_ocl_pf',

  // CommonBaseRecommendSourceDetail (1 type)
  COMMON_BASE_ETSURAN: 'CommonBase_etsuran',

  // NewJobSourceDetail (1 type)
  NEW_JOB_LIST: 'newjob_list',

  // NgRecommendSourceDetail (1 type)
  NG_RECOMMEND: 'ng_recommend',

  // AwsRecommendSkilltagResponseElementId (4 types)
  AWS_RECOMMEND_SKILLTAG_ORIGINAL: 'AWS_Recommend_skilltag_original',
  AWS_RECOMMEND_SKILLTAG_RESUME: 'AWS_Recommend_skilltag_resume',
  AWS_RECOMMEND_SKILLTAG_OUBO: 'AWS_Recommend_skilltag_oubo',
  AWS_RECOMMEND_SKILLTAG_VIEW: 'AWS_Recommend_skilltag_view',

  // W2vKyujinSyousaiRecommendElementId (2 types)
  W2V_KYUJIN_SYOUSAI_RECOMMEND: 'w2v_KyujinSyousai_recommend',
  W2V_CBM_KYUJIN_SYOUSAI_RECOMMEND: 'w2v_cbm_KyujinSyousai_recommend',

  // Element ID Constants (5 types)
  RECOMMEND_WILLCAN: 'Recommend_willcan',
  B4R_WILLCAN: 'B4R_willcan',
  B4R_CBM_GOUSEI_RERANK_RECOMMEND: 'b4r_cbm_gousei_rerank_recommend',
  AWS_RECOMMEND_OUBO_TSUUKA: 'AWS_Recommend_oubo_tsuuka',
  PLUS_SCOUT_LIST: 'plus_scout_list',
  VIEW_LIST: 'view_list',
} as const;

export type RecommendType =
  (typeof DODA_SITE_RECOMMENDTYPE)[keyof typeof DODA_SITE_RECOMMENDTYPE];
